import { observer } from 'mobx-react-lite';

import { TokenLogo } from 'components';
import { store } from 'store';
import { INITIAL_TOKENS } from 'store/swap/consts';
import { TokenInfo } from 'types';
import { cutAddress, cutTokenSymbol, getScanUrl } from 'utils/helpers';

import * as ModalS from './TokenSelectModal.styles';

export const TokenSelectSettings = observer(() => {
  const { tokenIn, tokenOut, selectToken } = store.swapStore;
  const { chainId } = store.web3Store;
  const { customTokens, removeCustomToken } = store.commonStore;

  const onRemoveClick = (token: TokenInfo) => {
    const initial = INITIAL_TOKENS[chainId];
    if (tokenIn?.address === token.address && tokenOut) {
      const freeToken = tokenOut.address === initial.in ? initial.out : initial.in;
      selectToken('in', freeToken);
    }
    if (tokenOut?.address === token.address && tokenIn) {
      const freeToken = tokenIn.address === initial.in ? initial.out : initial.in;
      selectToken('out', freeToken);
    }
    removeCustomToken(token);
  };

  return (
    <>
      <ModalS.Title>Custom Tokens</ModalS.Title>
      <ModalS.DividerLine />
      <ModalS.TokenList>
        {customTokens.map((t) => (
          <ModalS.TokenItem key={t.address}>
            <TokenLogo token={t} size={32} />
            <ModalS.TokenInfo>
              <ModalS.TokenSymbol>{t.name}</ModalS.TokenSymbol>
              <ModalS.TokenName>
                {cutTokenSymbol(t.symbol, 20)},{' '}
                <a
                  href={getScanUrl(`/token/${t.address}`, chainId)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {cutAddress(t.address)}
                </a>
              </ModalS.TokenName>
            </ModalS.TokenInfo>
            <ModalS.RemoveButton onClick={() => onRemoveClick(t)}>✕</ModalS.RemoveButton>
          </ModalS.TokenItem>
        ))}
      </ModalS.TokenList>
    </>
  );
});
